import {Produto} from "./Produto";

export class ImagemDoProduto {
  public id: number;

  constructor(public linkImagem: string, public ordem: number) {
  }
}
